import { BoardID } from 'BoardID';
import { deleteBoardFromLS, saveBoardToLS } from 'localStorage';
import { AccessTokens, Units } from 'Types';

import BoardBase from 'boardClasses/BoardBase';
import { createBoard, getCtor } from 'boardClasses/BoardFactory';

const { location } = window;

export async function fetchBoard(boardID: BoardID): Promise<BoardBase> {
  let rawBoard;

  rawBoard = await fetchJSON(
    `${location.origin}/.netlify/functions/queryBoardByID?id=${boardID}`
  );

  if (rawBoard == null) {
    return Promise.reject();
  }

  return parseAPIBoard(rawBoard);
}

export async function fetchUsersBoard({
  googleToken,
  facebookToken,
}: {
  googleToken: string | null;
  facebookToken: string | null;
}): Promise<Array<BoardBase>> {
  const headers = new Headers({
    'x-google-auth-token': googleToken ?? '',
    'x-facebook-auth-token': facebookToken ?? '',
  });
  const result = await fetchJSON(
    `${location.origin}/.netlify/functions/queryBoardsByToken`,
    {
      method: 'GET',
      headers,
    }
  );

  return Promise.resolve(result.map(parseAPIBoard));
}

export async function saveBoard(board: BoardBase, accessTokens: AccessTokens) {
  const { id, name, type, params } = board;
  const payload = {
    id,
    name,
    type,
    data: params,
  };

  saveBoardToLS(board);

  return fetch(`${location.origin}/.netlify/functions/upsertBoard?id=${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-google-auth-token': accessTokens.google ?? '',
      'x-facebook-auth-token': accessTokens.facebook ?? '',
    },
    body: JSON.stringify(payload),
  });
}

export async function deleteBoard(boardID: BoardID) {
  deleteBoardFromLS(boardID);
}

function parseAPIBoard(rawBoard: any): BoardBase {
  return createBoard(
    getCtor(rawBoard.type),
    rawBoard.id,
    rawBoard.name,
    JSON.parse(rawBoard.data_json),
    rawBoard.units || Units.IN
  );
}

type FetchParams = Parameters<typeof fetch>;
async function fetchJSON(url: FetchParams[0], options?: FetchParams[1]) {
  return await fetch(url, options).then((response) =>
    response.status === 200 ? response.json() : null
  );
}
